"use strict";

import axios from "@/util/axios";
import getCacheBuster from "@/util/getCacheBuster";
import { createSelector } from "reselect";

// import {getImages} from "./manufacturer";

const prefix = "catalog/spare-part-types";

export const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
export const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
export const FETCH_ENDED = `${prefix}/FETCH_ENDED`;

const initialState = {
  isFetching: false,
  data: null,
  filter: {},
  error: false,
};

const fetchStart = (filter) => ({ type: FETCH_STARTED, payload: { filter: filter } });
const fetchEnd = (data) => ({ type: FETCH_ENDED, payload: data });
const fetchFail = () => ({ type: FETCH_FAILED });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        filter: action.payload.filter || {},
        isFetching: true,
        error: false,
      };

    case FETCH_ENDED:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: false,
      };

    case FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        error: true,
      };

    default:
      return state;
  }
}

const sparePartTypesSelector = (state) => state.sparePartTypes;

export const getIsSparePartTypesFetching = createSelector(sparePartTypesSelector, (data) => data.isFetching);

export const getSparePartTypes = createSelector(sparePartTypesSelector, (data) => data.data || []);

// export const getSparePartTypes = createSelector(
//   getSparePartTypesBase,
//   getImages,
//   (data, images) =>  data.map(rec => ({
//     ...rec,
//     images: images[rec.id]
//   }))
// );

export const getSparePartTypesFilter = createSelector(sparePartTypesSelector, (data) => data.filter || {});

export const hasSparePartTypesFetched = createSelector(getSparePartTypes, (sparePartTypes) => sparePartTypes.length > 0);

export function fetchSparePartTypes(filter) {
  return (dispatch) => {
    dispatch(fetchStart(filter));
    axios
      .get("api/category/", {
        params: {
          ...filter,
          _: getCacheBuster(),
        },
      })
      .then((res) => {
        dispatch(fetchEnd(res.data));
      })
      .catch(() => {
        dispatch(fetchFail());
      });
  };
}

export function fetchSparePartTypesCached() {
  return (dispatch, getState) => {
    const state = getState();
    const data = getSparePartTypes(state);

    if (!getIsSparePartTypesFetching(state) && data.length === 0) {
      dispatch(fetchSparePartTypes());
    }
  };
}
